import { useMutation } from "@tanstack/react-query"
import { toast } from "sonner"

import { supabase } from "@/lib/supabase"

export const useEmailApplicantsByStage = () => {
  return useMutation({
    mutationFn: async ({ stage, redirectUrl }: { stage: string; redirectUrl: string }) => {
      try {
        const { data, error } = await supabase.functions.invoke("email-inprogress-applicants", {
          body: {
            stage,
            redirectUrl,
          },
        })

        if (error) {
          throw new Error(error.message)
        }

        return data
      } catch (error) {
        console.error(`Error emailing ${stage} applicants:`, error)
        throw error
      }
    },
    onSuccess: (_, variables) => {
      toast.success("Success", {
        description: `Email notifications sent to applicants in ${variables.stage} stage.`,
      })
    },
    onError: (error) => {
      toast.error("Error", {
        description: `Failed to send emails: ${error.message}`,
      })
    },
  })
}
